import { Component, EventEmitter, Output } from '@angular/core';

import { RCS_MEDIA_CATEGORIES, RcsMedia } from 'src/app/models/Rcs';
import { RcsMediaService } from 'src/app/shared/services/rcs-media.service';

/**
 * Formulário curto de upload para a galeria RCS. Vive em dois lugares — a aba
 * Galeria dos agentes e o modal de escolha do editor — e por isso é componente:
 * quem está montando uma mensagem não precisa sair dela para subir a imagem.
 */
@Component({
  selector: 'app-rcs-media-upload',
  templateUrl: './rcs-media-upload.component.html',
})
export class RcsMediaUploadComponent {
  @Output() uploaded = new EventEmitter<RcsMedia>();
  @Output() cancelled = new EventEmitter<void>();

  readonly categories = RCS_MEDIA_CATEGORIES;

  file: File | null = null;
  title = '';
  category = RCS_MEDIA_CATEGORIES[0];
  saving = false;
  error = '';

  constructor(private mediaService: RcsMediaService) {}

  onFile(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.file = input.files && input.files.length ? input.files[0] : null;
    this.error = '';

    if (this.file && !/^image\/(png|jpe?g|gif|webp)$/.test(this.file.type)) {
      this.error = 'Envie uma imagem JPG, PNG, GIF ou WebP.';
      this.file = null;
      return;
    }

    if (this.file && !this.title.trim()) {
      this.title = this.file.name.replace(/\.[^.]+$/, '');
    }
  }

  get canSave(): boolean {
    return !!this.file && !!this.title.trim() && !this.saving;
  }

  save(): void {
    if (!this.canSave) {
      this.error = this.file ? 'Dê um título para a imagem.' : 'Escolha a imagem.';
      return;
    }

    this.saving = true;
    this.error = '';
    this.mediaService.upload(this.file, this.title.trim(), this.category).subscribe({
      next: media => {
        this.saving = false;
        this.file = null;
        this.title = '';
        this.uploaded.emit(media);
      },
      error: response => {
        this.saving = false;
        const errors = response?.error?.errors || {};
        this.error = (errors.image || errors.title || errors.category || [])[0]
          || response?.error?.message
          || 'Não foi possível enviar a imagem. Tente de novo.';
      },
    });
  }
}
